import { VariantColor } from '@repo/toolkit/colors'

import { LocaleKeys } from '../../../../locale/translation-types'

export enum EndOfJourneyScanItemStatusEnum {
  TO_PROCESS = 'TO_PROCESS',
  PROCESSING = 'PROCESSING',
  PROCESSED = 'PROCESSED',
  FAILED = 'FAILED'
}

export enum EndOfJourneyScanFailureEnum {
  UNREADABLE = 'UNREADABLE',
  UNIDENTIFIED = 'UNIDENTIFIED',
  ENROLLMENT_NOT_FOUND = 'ENROLLMENT_NOT_FOUND',
  AMBIGUOUS_ENROLLMENT = 'AMBIGUOUS_ENROLLMENT',
  IDENTITY_MISMATCH = 'IDENTITY_MISMATCH',
  TEMPLATE_NOT_FOUND = 'TEMPLATE_NOT_FOUND',
  ALREADY_RECEIVED = 'ALREADY_RECEIVED',
  INVALID_ANSWERS = 'INVALID_ANSWERS',
  EXTRACTION_ERROR = 'EXTRACTION_ERROR'
}

// Why a question of a read questionnaire was uncertain (saved blank, to check on the scan)
export enum EndOfJourneyScanUncertainTypeEnum {
  SEVERAL_MARKED = 'SEVERAL_MARKED',
  UNCLEAR_MARK = 'UNCLEAR_MARK',
  ERASED = 'ERASED',
  OUTSIDE_BOXES = 'OUTSIDE_BOXES',
  OTHER = 'OTHER'
}

// Whether the questionnaires can be read now, or why the reading is paused (uploads are never blocked)
export enum EndOfJourneyScanReadingStateEnum {
  AVAILABLE = 'AVAILABLE',
  NO_API_KEY = 'NO_API_KEY',
  KEY_REJECTED = 'KEY_REJECTED',
  NO_CREDIT = 'NO_CREDIT',
  RATE_LIMITED = 'RATE_LIMITED',
  OVERLOADED = 'OVERLOADED',
  NO_TEMPLATE = 'NO_TEMPLATE'
}

export const endOfJourneyScanItemStatusMapping: Record<
  EndOfJourneyScanItemStatusEnum,
  { label: LocaleKeys; variant: VariantColor }
> = {
  TO_PROCESS: { label: 'end.of.journey.scans.status.to.process', variant: 'grey' },
  PROCESSING: { label: 'end.of.journey.scans.status.processing', variant: 'blue' },
  PROCESSED: { label: 'end.of.journey.scans.status.processed', variant: 'success' },
  FAILED: { label: 'end.of.journey.scans.status.failed', variant: 'danger' }
}

export const endOfJourneyScanFailureMapping: Record<EndOfJourneyScanFailureEnum, LocaleKeys> = {
  UNREADABLE: 'end.of.journey.scans.failure.unreadable',
  UNIDENTIFIED: 'end.of.journey.scans.failure.unidentified',
  ENROLLMENT_NOT_FOUND: 'end.of.journey.scans.failure.enrollment.not.found',
  AMBIGUOUS_ENROLLMENT: 'end.of.journey.scans.failure.ambiguous.enrollment',
  IDENTITY_MISMATCH: 'end.of.journey.scans.failure.identity.mismatch',
  TEMPLATE_NOT_FOUND: 'end.of.journey.scans.failure.template.not.found',
  ALREADY_RECEIVED: 'end.of.journey.scans.failure.already.received',
  INVALID_ANSWERS: 'end.of.journey.scans.failure.invalid.answers',
  EXTRACTION_ERROR: 'end.of.journey.scans.failure.extraction.error'
}

export const endOfJourneyScanUncertainTypeMapping: Record<
  EndOfJourneyScanUncertainTypeEnum,
  LocaleKeys
> = {
  SEVERAL_MARKED: 'end.of.journey.scans.uncertain.type.several.marked',
  UNCLEAR_MARK: 'end.of.journey.scans.uncertain.type.unclear.mark',
  ERASED: 'end.of.journey.scans.uncertain.type.erased',
  OUTSIDE_BOXES: 'end.of.journey.scans.uncertain.type.outside.boxes',
  OTHER: 'end.of.journey.scans.uncertain.type.other'
}

// Why the reading is paused, shown on "Traitement des questionnaires"
export const endOfJourneyScanReadingPausedMapping: Record<
  Exclude<EndOfJourneyScanReadingStateEnum, EndOfJourneyScanReadingStateEnum.AVAILABLE>,
  LocaleKeys
> = {
  NO_API_KEY: 'end.of.journey.scans.reading.paused.no.api.key',
  KEY_REJECTED: 'end.of.journey.scans.reading.paused.key.rejected',
  NO_CREDIT: 'end.of.journey.scans.reading.paused.no.credit',
  RATE_LIMITED: 'end.of.journey.scans.reading.paused.rate.limited',
  OVERLOADED: 'end.of.journey.scans.reading.paused.overloaded',
  NO_TEMPLATE: 'end.of.journey.scans.reading.paused.no.template'
}
